import { FetchError } from "@freightsimple/generated-dashboard-openapi-client/runtime";

/** True when the browser got no answer from the API at all (the phone lost
 *  its connection, or Safari cancelled the request). A background fetch that
 *  hits one should keep what it already has and let the next refresh retry.
 *  An answer with an error status is a ResponseError, not this. */
export function isNetworkError(error: unknown): boolean {
  return error instanceof FetchError;
}
